import React, { FunctionComponent, UIEvent } from 'react'
import { useDebouncedCallback } from 'use-debounce'

import { useBreakpoint } from '../useBreakpoint'
import { CarouselProps } from './Carousel'
import { CarouselItem } from './CarouselItem'
import styles from './style.module.scss'

export interface CarouselScrollSliderProps
  extends Omit<CarouselProps, 'onChange' | 'prevButtonAriaLabel' | 'nextButtonAriaLabel' | 'alwaysShowTheNextButton'> {}

export const CarouselScrollSlider: FunctionComponent<CarouselScrollSliderProps> = ({
  children,
  Small = 2,
  Medium = 4,
  Large = 6,
  testNameSpace = '',
  keyNameSpace = '',
  onScroll,
}) => {
  const sliderTestNameSpace = testNameSpace.length > 0 ? `${testNameSpace}-carousel-scroll-slider` : 'carousel-scroll-slider'
  const itemKeyPrefix = keyNameSpace.length > 0 ? `${keyNameSpace}-carousel-scroll-item` : 'carousel-scroll-item'

  const { screenSize } = useBreakpoint()

  const childrenArr = React.Children.toArray(children)

  const maxItemsSize = screenSize === 'Large' ? Large : screenSize === 'Medium' ? Medium : screenSize === 'Small' ? Small : Large

  const onScrollHandler = useDebouncedCallback((e: UIEvent): void => {
    if (typeof onScroll === 'undefined' || e.target === null) {
      return
    }
    const target = e.target as Element
    onScroll(target.scrollLeft, target.clientWidth, target.scrollWidth)
  }, 200)

  return (
    <div className={styles.scrollSlideContainer}>
      <ul className={styles.scrollSlide} data-testid={sliderTestNameSpace} onScroll={typeof onScroll === 'undefined' ? undefined : onScrollHandler}>
        {childrenArr.map((item, index) => (
          <CarouselItem key={`${itemKeyPrefix}-${index}`} maxItemsSize={maxItemsSize}>
            {item}
          </CarouselItem>
        ))}
      </ul>
    </div>
  )
}
